export default (): Record<string, unknown> => ({
  timeout: 30000,
});
